import { AutogenLayoutCarrierOfferAcceptPdfDialog } from "./autogen/AutogenLayoutCarrierOfferAcceptPdfDialog";
import {  ClickEvent } from "@mcleod/components";

export class CarrierOfferAcceptPdfDialog extends AutogenLayoutCarrierOfferAcceptPdfDialog {


}
